import Layout from '@/layout'
const syWarrantyRouter = {
  path: '/sy_warranty',
  component: Layout,
  name: 'syWarranty',
  meta: {
    title: '圣耀电子质保管理',
    icon: 'el-icon-document-copy',
    roles: ['root', 'sy_company', 'sy_shop', 'business']
  },
  children: [
    {
      path: 'create',
      name: 'WarrantyCreate',
      component: () => import('@/views/sy_warranty/create'),
      meta: { title: '质保创建', icon: 'el-icon-plus', noCache: true }
    },
    {
      path: 'update',
      name: 'WarrantyUpdate',
      component: () => import('@/views/sy_warranty/update'),
      meta: { title: '质保更新', icon: 'el-icon-plus', noCache: true },
      hidden: true
    },
    {
      path: 'table',
      name: 'WarrantyTable',
      component: () => import('@/views/sy_warranty/table'),
      meta: { title: '质保查询', icon: 'el-icon-search', noCache: false }
    },
    {
      path: 'export_records',
      name: 'SyWarrantyExportRecords',
      component: () => import('@/views/sy_warranty/export_records'),
      meta: { title: '导出记录', icon: 'el-icon-download', roles: ['root'], noCache: false }
    }
  ]
}
export default syWarrantyRouter
